export default "__VITE_ASSET__6a2f4b0d__"